module.exports = __webpack_public_path__ + "assets/media/day27.656c7c78.mp3";